import { Directive, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { AddressFieldsetComponentDef } from '@df/ui/form/address-fieldset.component.def';
import { Subject, Subscription } from 'rxjs';
export const NAME_PREFIXES = ['Dr', 'Mr', 'Mrs', 'Miss', 'Ms', 'Rev', 'Other'];

declare module '@df/ui/form/address-searcher' {
    export interface IHint {
        suggestion: string;
    }

}
@Directive()
// tslint:disable-next-line: directive-class-suffix
export abstract class AbstractAccountAddressFieldsetComponent extends AddressFieldsetComponentDef implements OnInit, OnChanges, OnDestroy {
    @ViewChild('phoneInput')
    phoneInput?: ElementRef;
    public prefixes = NAME_PREFIXES;
    @Input()
    submitSubject?: Subject<boolean>;
    protected formSubmittedSubscription?: Subscription;
    private _displayForm?: boolean;
    private _telephoneNumber = '';
    override ngOnInit(): void {
        super.ngOnInit();
        if (this.data && this.data.street_1) {
            this.displayFormLocal = true;
        }
    }
    override ngOnChanges(changesObj: SimpleChanges) {
        super.ngOnChanges(changesObj);
        if (changesObj['submitSubject']) {
            this.clearSubmitSubscription();
            if (this.submitSubject) {
                this.formSubmittedSubscription = this.submitSubject.subscribe((value: boolean) => {
                    if (value && !this.addressIsValid) {
                        this.displayFormLocal = true;
                    }
                });
            }
        }
        if (changesObj['data'] && this.data) {
            this.telephoneNumber = this.data.telephone || '';
        }
    }
    override ngOnDestroy(): void {
        super.ngOnDestroy();
        this.clearSubmitSubscription();
    }
    set telephoneNumber(value: string) {
        const cleanValue = (value || '').replace(/\s/g, '');
        value = cleanValue;
        if (cleanValue.length > 5) {
            value = cleanValue.slice(0, 5) + ' ' + cleanValue.slice(5);
            if (value.length > 9) {
                value = value.slice(0, 9) + ' ' + value.slice(9);
            }
        }
        this._telephoneNumber = value;
        this.data.telephone = cleanValue;
        if (this.phoneInput?.nativeElement) {
            this.phoneInput.nativeElement.value = value;
        }
        this.detectChanges();
    }
    get telephoneNumber(): string {
        return this._telephoneNumber;
    }
    protected clearSubmitSubscription(): void {
        if (this.formSubmittedSubscription) {
            this.formSubmittedSubscription.unsubscribe();
        }
    }
    set displayFormLocal(value: boolean) {
        this._displayForm = value;
        this.detectChanges();
    }
    get displayFormLocal() {
        return !!this._displayForm;
    }
    get addressIsValid(): boolean {
        const address = this.data;
        if (address) {
            return !!(address.firstname &&
                address.lastname &&
                address.telephone &&
                address.country_id &&
                address.postcode &&
                address.street_1 &&
                address.city &&
                (!this.regionRequired || address.region || address.region_id));
        }
        return false;
    }
    override onSearcherSelectionApplied(): void {
        super.onSearcherSelectionApplied();
        this.displayFormLocal = true;
    }
}
